import { useQuery } from '@tanstack/react-query';
import { fetchDmCompliance, type ComplianceData } from '../services/patient/dmCompliance';

const COMPLIANCE_STALE_TIME_MS = 5 * 60 * 1000;

/** Aligner pace + scan-lateness compliance stats, gated on `dmId` exactly
 *  like `useDmScans` — unlinked patients never fetch. */
export function useDmCompliance(patientId: string | undefined, dmId: number | null | undefined) {
    const { data, error, isLoading } = useQuery<ComplianceData | null>({
        queryKey: ['patient', patientId, 'monitoring', 'compliance'],
        queryFn: () => fetchDmCompliance(patientId as string),
        enabled: !!patientId && !!dmId,
        staleTime: COMPLIANCE_STALE_TIME_MS,
        retry: 1
    });

    return { data: data ?? null, isLoading, error };
}
